export interface Form {
  id?: string;
  title?: string;
  icon?: {
    id?: string;
    type?: string;
  };
  cover?: string;

  description?: string;
  isFetching?: boolean;
  logo?: {
    image: string;
    alt: string;
  };
  showSketchnoteBranding?: boolean;
  showCover?: boolean;
  redirect?: {
    url?: string;
    isRedirect: boolean;
  };
  redirectUrl?: string;
  submission?: {
    buttonText?: string;
    message?: string;
  };
  design?: {
    backgroundColor?: string;
  };
  fields?: FormField[];
  isActive?: boolean;
  status?: string;
  timer?: number;
  captchaEnabled?: boolean;
  formToTaskMap?: FormToTaskMap;
}

export type FormToTaskMap = {
  file: {
    _id: string;
    title: string;
    workspace: string;
  };
  field: string;
};

export type FormField = {
  title?: string;
  responseType?: FormResponseType;
  description?: string;
  isRequired?: boolean;
  placeholder?: string;
  randomiseOptions?: boolean;
  _id?: string;
  image?: string;
  showImage?: boolean;
  lowerRange?: number;
  higherRange?: number;
  ratingStyle?: 'heart' | 'star' | 'smile';
  lowerRangeLabel?: string;
  higherRangeLabel?: string;
  dateRange?: [Date, Date] | [Date] | [string] | [string, string] | null;
  fileTypes?: FileUploadType[] | null;
  maxFilesCount?: number | null;
  maxFileSize?: number | null;
  options?: FormOption[];
  index?: number;
};

export type FormOption = {
  label: string;
  value: string;
  image?: string;
  optionId?: string;
  isSelected?: boolean;
};

export type FormResponseType =
  | 'short-text'
  | 'paragraph'
  | 'linear-scale'
  | 'star-rating'
  | 'radio-box'
  | 'checkbox'
  | 'dropdown'
  | 'email'
  | 'date-picker'
  | 'upload'
  | 'phone';

export type FormSettingsPage = 'home' | 'response' | 'timer' | 'form-to-task' | 'share-results';

export type FileUploadType = 'document' | 'powerpoint' | 'word' | 'excel' | 'web_formats';

export const FileUploadTypes = {
  document: {
    key: 'document',
    label: 'Document (.pdf)',
    extensions: ['.pdf'],
  },
  powerpoint: {
    key: 'powerpoint',
    label: 'Microsoft Powerpoint (.pptx)',
    extensions: ['.pptx'],
  },
  word: {
    key: 'word',
    label: 'Microsoft Word (.docx, .doc)',
    extensions: ['.docx', '.doc'],
  },
  excel: {
    key: 'excel',
    label: 'Microsoft Excel (.xlsx)',
    extensions: ['.xlsx'],
  },
  web_formats: {
    key: 'web_formats',
    label: 'Web formats (.svg, .webp)',
    extensions: ['.svg', '.webp'],
  },
};

export type FormSummary = {
  fields?: FromSummaryFieldType[];
  _id?: string;
  options?: { label: string; value: string; image?: string }[];
  index?: number;
};

type FromSummaryFieldType = {
  title?: string;
  responseType?: FormResponseType;
  description?: string;
  responses?: any;
};
